<ion-content>
  <div class="flex flex-col px-3 py-3">
    <span class="font-normal text-lg py-[2px]">
      <a href="/global-settings">Global Settings</a>
    </span>
    <span class="font-normal text-lg py-[2px]">
      <a [routerLink]="'/user-setting'" (click)="popover.dismiss();" >User Settings</a>
    </span>
    <!-- <span class="font-normal text-lg py-[2px]">
      <a href="#">Calendar </a>
    </span> -->
    <span class="font-normal text-lg py-[2px] cursor-pointer">
      <span (click)="logout()">Logout </span>
    </span>
  </div>
</ion-content>
